import { applyMiddleware, createStore } from 'redux';
import logger from 'redux-logger';
import createSagaMiddleware from 'redux-saga';

import reducers from './reducers';
import sagas from './sagas';

const sagaMiddleware = createSagaMiddleware();
let middlewares = [sagaMiddleware];
if (process.env.NODE_ENV === 'development') middlewares = [sagaMiddleware, logger];

function configureStore(initialState) {
  const store = createStore(reducers, initialState, applyMiddleware(...middlewares));
  sagaMiddleware.run(sagas);
  return store;
}

const store = configureStore();
export default store;
